import { jsx as g } from "react/jsx-runtime";
import { useRef as S, useState as y, useEffect as C, useCallback as R } from "react";
import U from "../../resources/graphics/placeholder/image-placeholder.svg.js";
import { Container as _ } from "./styles.js";
function z({
  alt: l,
  className: L,
  errorImage: t,
  src: f,
  onError: e,
  loading: d = "lazy",
  placeholderImage: i,
  children: a,
  ...o
}) {
  const u = S(null), [n, s] = y(f), [m, c] = y(!0);
  C(() => {
    s(f);
  }, [f]), C(() => {
    var p;
    (p = u.current) != null && p.complete && c(!1);
  }, [u]);
  const x = R(() => {
    if (e == null || e(), c(!1), t && n !== t) {
      s(t);
      return;
    }
    s(U);
  }, [t, e, n]), A = R(() => {
    c(!1);
  }, []);
  if (typeof a == "function")
    return a({
      alt: l,
      className: L,
      errorImage: t,
      src: f,
      source: n,
      loadingImg: m,
      onError: e,
      loading: d,
      placeholderImage: i,
      children: a,
      ...o
    });
  const D = o.fetchPriority !== "high" && i ? m : !1;
  return /* @__PURE__ */ g(
    _,
    {
      "data-loading": D,
      className: L,
      style: {
        "--placeholder-image": `url(${i})`
      },
      children: /* @__PURE__ */ g(
        "img",
        {
          ref: u,
          src: n,
          alt: l,
          loading: d,
          onError: x,
          onLoad: A,
          ...o
        }
      )
    }
  );
}
export {
  z as Image
};
